import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from './SfhSecondaryButton';

// Scoped drawer title/subtitle nodes (Instrument Sans) so the shared Drawer
// header stays unchanged for other drawers.
const DrawerTitle = styled.span`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  color: ${themeColors.colorTextPrimary};
`;

const DrawerSubtitle = styled.span`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
`;

const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StepTag = styled.span`
  display: inline-block;
  background-color: ${themeColors.colorTextSecondary};
  color: ${themeColors.colorWhite};
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 500;
  border-radius: 2px;
  padding: 2px 8px;
  width: fit-content;
`;

const StepTitle = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  margin: 0;
`;

const StepDescription = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  line-height: 18px;
  margin: 0;
`;

const FooterDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${themeColors.colorBorderPrimary};
  margin: 0 -16px 16px;
`;

const FooterNote = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  line-height: 18px;
  margin: 0 0 16px;

  > strong {
    font-weight: 700;
    color: ${themeColors.colorTextSecondary};
  }
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    font-family: ${variables.family.goldSilver}, sans-serif;
    font-weight: 600;
    color: ${themeColors.colorPrimary};
  }
`;

const SellFromHomeStepsDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <FooterDivider />
      <FooterNote>
        <strong>{t('sellWizard.sellFromHomeSteps.noteLabel')}</strong>{' '}
        {t('sellWizard.sellFromHomeSteps.footerNote')}
      </FooterNote>
      <SfhSecondaryButton onClick={onClose} data-cy="button-sfh-steps-cta">
        {t('sellWizard.sellFromHomeSteps.cta')}
      </SfhSecondaryButton>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={
        <DrawerTitle>{t('sellWizard.sellFromHomeSteps.title')}</DrawerTitle>
      }
      subtitle={
        <DrawerSubtitle>
          {t('sellWizard.sellFromHomeSteps.subtitle')}
        </DrawerSubtitle>
      }
      footer={footer}
      maxHeight="70%"
    >
      <StepsList>
        <StepItem>
          <StepTag>{t('sellWizard.sellFromHomeSteps.step1.tag')}</StepTag>
          <StepTitle>{t('sellWizard.sellFromHomeSteps.step1.title')}</StepTitle>
          <StepDescription>
            {t('sellWizard.sellFromHomeSteps.step1.description')}
          </StepDescription>
          {/* <StepNote>
            <strong>{t('sellWizard.sellFromHomeSteps.noteLabel')}</strong>{' '}
            {t('sellWizard.sellFromHomeSteps.step1.note')} 
          </StepNote> */}
        </StepItem>
        <StepItem>
          <StepTag>{t('sellWizard.sellFromHomeSteps.step2.tag')}</StepTag>
          <StepTitle>{t('sellWizard.sellFromHomeSteps.step2.title')}</StepTitle>
          <StepDescription>
            {t('sellWizard.sellFromHomeSteps.step2.description')}
          </StepDescription>
        </StepItem>
      </StepsList>
    </BottomDrawer>
  );
};

SellFromHomeStepsDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomeStepsDrawer;
